// Keep local quote dates in their stored calendar day; parsing a date-only
// value as an instant can shift it into the previous day in another timezone.
export const compareQuoteShifts = (left: any, right: any): number => {
  const day = (shift: any) => String(shift?.startDate || '').split('T')[0];
  const minutes = (shift: any) => {
    const [hour, minute] = String(shift?.startTime || '00:00').split(':').map(Number);
    return Number.isFinite(hour + minute) ? hour * 60 + minute : 0;
  };
  return day(left).localeCompare(day(right)) || minutes(left) - minutes(right);
};

// Undated draft rows stay at the end. Preserve object identity and stable ties,
// and reuse the original array when no reorder is needed.
export const orderQuoteRows = <T extends { startDate?: string | null; startTime?: string | null }>(rows: T[]): T[] => {
  const ordered = [...rows].sort((left, right) => {
    const leftDated = Boolean(left.startDate);
    const rightDated = Boolean(right.startDate);
    if (leftDated !== rightDated) return leftDated ? -1 : 1;
    return leftDated ? compareQuoteShifts(left, right) : 0;
  });
  return ordered.every((row, index) => row === rows[index]) ? rows : ordered;
};

export const groupQuoteRowsInEntryOrder = (
  positions: any[],
  totalFor: (row: any) => number,
  dateFor: (row: any) => string = row => row.startDate
) =>
  positions.reduce((groups, position) => {
    const date = String(dateFor(position) || '').split('T')[0];
    const last = groups[groups.length - 1];
    if (last?.date === date) {
      last.positions.push(position);
      last.total += totalFor(position);
    } else groups.push({ date, positions: [position], total: totalFor(position) });
    return groups;
  }, [] as Array<{ date: string; positions: any[]; total: number }>);
